import React from 'react';
import { SrOnly } from '@husslehq/ui-library';
import styles from '../../components/Burger/Burger.module.scss';

export type BurgerProps = {
  onClick: () => void;
};

export const Burger: React.FC<BurgerProps> = ({ onClick }) => {
  return (
    <button type="button" className={styles.burger} onClick={onClick}>
      <SrOnly>Toggle menu view</SrOnly>
    </button>
  );
};
